import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';

import { logoIcon } from '../../assets';
import { setToastInfo, setToastVisible, useAppDispatch, useAppSelector } from '../../state';
import { ChatModelType } from '../../types';
import BackButton from '../EditHeader/BackButton';
import Notification from '../EditHeader/Notification';
import { LocalImage } from '../Image';

interface IEditHeaderProps {
  onPublish?: () => void;
  styles: Record<string, string>;
  backUrl?: string;
}

const PAGE = 'create_npc_advanced_page';

// dialog_model_choice埋点 对话模型：dialog、工具模型:tool、若无则为空
export const getImageModelChoice = (chat_model_type: ChatModelType | any) => {
  return chat_model_type === ChatModelType.Chat
    ? 'dialog'
    : chat_model_type === ChatModelType.Util
      ? 'tool'
      : '';
};

export function ImageCreationHeader(props: IEditHeaderProps) {
  const { styles, backUrl } = props;

  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const { isToastVisible, toastStatus } = useAppSelector((state) => state.edit);

  const onClose = useCallback(() => {
    dispatch(setToastVisible(false));
    dispatch(setToastInfo(undefined));
    if (toastStatus === 'success') {
      location.href = '/create';
    }
  }, [toastStatus]);

  return (
    <header className={styles.header}>
      <section className={styles.headerSection}>
        <BackButton styles={styles} backUrl={backUrl} />
      </section>

      <div className={styles.logo}>
        <LocalImage src={logoIcon} />
      </div>

      <div className={styles.title}>{t('image_creation')}</div>

      {/* 发布状态Toast */}
      <Notification type={toastStatus} styles={styles} onClose={onClose} open={isToastVisible} />
    </header>
  );
}

export default ImageCreationHeader;
